<template>
    <div style="display:inline-block">
        <!-- <canvas id="s-canvas" :width="contentWidth" :height="contentHeight" @click="changenum()"></canvas> -->
        <canvas v-if="!isKey" :id="IdName" :width="contentWidth" :height="contentHeight" @click="changenum()"></canvas>
        <img v-if="isKey" :src="imgSrc" alt="" @click="changenum()">
    </div>
</template>
<script>
    export default{
        props:{
            IdName:String,
            isKey:Boolean,
        },
        data(){
            return{
                contentWidth:155,
                contentHeight:35,
                fontSizeMin:16,
                fontSizeMax:40,
                backgroundColorMin:180,
                backgroundColorMax: 240,
                colorMin:50,
                colorMax:160,
                lineColorMin:40,
                lineColorMax:180,
                identifyCode:'5896',//要显示的数字
                imgSrc:'',
                imgKey:null,
            }
        },
        mounted(){
            this.changenum()
           
        },
        computed: {
            isChangeNum(){
                // console.log(this.$store.state.isChangeNum)
                if(this.$store.state.isChangeNum){
                    this.changenum()  
                }
                return this.$store.state.isChangeNum
            }
        },
        watch: {
            isChangeNum(val) {
                // console.log(val)
            },
        },
        methods:{
            async changenum(){
                if(this.isKey){
                    const res = await this.$api.getImgYzm()
                   
                    if(res.code == '0'){
                        this.imgSrc = res.data.image
                        this.imgKey = res.data.key
                        this.$emit('getimgKey',this.imgKey)
                    }
                }else{
                    this.identifyCode =  Math.round(Math.random() * 10000) + ''
                    this.drawPic()
                }
                this.$store.state.isChangeNum = false
                
            },
            drawPic(){
                let canvas = document.getElementById(this.IdName)
                let ctx = canvas.getContext('2d')
                ctx.textBaseline = 'bottom'
                // 绘制背景
                ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax)
                ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)
                // 绘制文字
                for (let i = 0; i < this.identifyCode.length; i++) {
                    this.drawText(ctx, this.identifyCode[i], i)
                }
                this.drawLine(ctx)
                this.drawDot(ctx)
            },
            drawText (ctx, txt, i) {
                ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax)
                ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei'
                let x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1))
                let y = this.randomNum(this.fontSizeMax, this.contentHeight - 5)
                var deg = this.randomNum(-45, 45)
                // 修改坐标原点和旋转角度
                ctx.translate(x, y)
                ctx.rotate(deg * Math.PI / 180)
                ctx.fillText(txt, 0, 0)
                // 恢复坐标原点和旋转角度
                ctx.rotate(-deg * Math.PI / 180)
                ctx.translate(-x, -y)
            },
            drawLine (ctx) {
                // 绘制干扰线
                for (let i = 0; i < 8; i++) {
                ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax)
                ctx.beginPath()
                ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight))
                ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight))
                ctx.stroke()
                }
            },
            drawDot (ctx){
                // 绘制干扰点
                for (let i = 0; i < 100; i++) {
                ctx.fillStyle = this.randomColor(0, 255)
                ctx.beginPath()
                ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI)
                ctx.fill()
                }
            },
            // 生成一个随机数
            randomNum (min, max) {
                let num = Math.floor(Math.random() * (max - min) + min)
                return num
            },
            // 生成一个随机的颜色
            randomColor (min, max) {
                let r = this.randomNum(min, max)
                let g = this.randomNum(min, max)
                let b = this.randomNum(min, max)
                return 'rgb(' + r + ',' + g + ',' + b + ')'
            },
        }
    }
</script>
<style scoped lang="less"> 

</style>